import React, { useState, useEffect } from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import { motion, AnimatePresence } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import { useLanguage } from '../context/LanguageContext';

const Navbar = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const { lang, t, toggleLang } = useLanguage();
  const location = useLocation();
  const isHome = location.pathname === '/';

  useEffect(() => {
    const handleScroll = () => setIsScrolled(window.scrollY > 50);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navClasses = `fixed w-full z-50 transition-all duration-500 ${
    isScrolled || !isHome ? 'bg-gallery-bg/95 backdrop-blur-md py-4 shadow-sm text-gallery-text' : 'bg-transparent py-6 text-white'
  }`;

  const linkClass = ({ isActive }) =>
    `text-sm tracking-widest uppercase transition-colors hover:text-gallery-accent ${
      isActive ? 'text-gallery-accent' : ''
    }`;

  const navLinks = [
    { path: '/', label: 'nav.home' },
    { path: '/gallery', label: 'nav.gallery' },
    { path: '/about', label: 'nav.about' },
    { path: '/contact', label: 'nav.contact' },
  ];

  return (
    <nav className={navClasses}>
      <div className="max-w-7xl mx-auto px-6 flex justify-between items-center">
        {/* Logo - Removed all background/box styling */}
        <NavLink 
          to="/" 
          className={() => "font-serif text-xl tracking-[0.2em] uppercase !bg-transparent border-none p-0 no-underline"}
        >
          Gisselle Mendez
        </NavLink>

        {/* Desktop Links */}
        <div className="hidden md:flex items-center space-x-8">
          {navLinks.map((link) => (
            <NavLink key={link.path} to={link.path} className={linkClass}>
              {t(link.label)}
            </NavLink>
          ))}
          <button 
            onClick={toggleLang}
            className="text-sm tracking-widest uppercase hover:text-gallery-accent transition-colors"
          >
            {lang === 'es' ? 'EN' : 'ES'}
          </button>
        </div>

        {/* Mobile Toggle */}
        <div className="md:hidden flex items-center">
          <button onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}>
            <SafeIcon name={isMobileMenuOpen ? "X" : "Menu"} className="w-6 h-6" />
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      <AnimatePresence>
        {isMobileMenuOpen && (
          <motion.div
            initial={{ opacity: 0, y: -20 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -20 }}
            className="absolute top-full left-0 w-full bg-gallery-bg shadow-lg py-6 px-6 flex flex-col space-y-4 md:hidden text-gallery-text"
          >
            {navLinks.map((link) => (
              <NavLink 
                key={link.path} 
                to={link.path} 
                onClick={() => setIsMobileMenuOpen(false)}
                className="text-lg font-serif tracking-wide"
              >
                {t(link.label)}
              </NavLink>
            ))}
            <div className="pt-4 border-t border-gallery-border flex justify-between items-center">
              <button onClick={toggleLang} className="text-sm tracking-widest uppercase">
                Language: {lang === 'es' ? 'English' : 'Español'}
              </button>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </nav>
  );
};

export default Navbar;